'use strict';

/* exported
 referralsListCtrl
  */

function referralsListCtrl($scope, $window, referrals, appConfig, CurrenciesService, Restangular) {
  $scope.currenciesService = CurrenciesService;
  $scope.appConfig = appConfig;
  $scope.filters = {};
  $scope.limit = 20;
  $scope.offset = 0;
  $scope.currentPage = 1;
  $scope.selected = null;

  applyResponse(referrals);

  function applyResponse(response) {
    $scope.referrals = response || [];
    $scope.total = (response && response.meta && response.meta.total) || 0;
  }

  function fetch() {
    $scope.filters.offset = $scope.offset;
    $scope.filters.limit = $scope.limit;

    Restangular.all('referral-rewards').getList($scope.filters).then(applyResponse);
  }

  $scope.pageChanged = function() {
    $scope.offset = ($scope.currentPage - 1) * $scope.limit;
    fetch();
  };

  $scope.toggleDetails = function(referral) {
    $scope.selected = $scope.selected === referral ? null : referral;
  };

  function updateFilter(filterKey, data) {
    if (data === null || data === undefined || data === '') {
      delete $scope.filters[filterKey];
    } else {
      $scope.filters[filterKey] = data;
    }
    $scope.offset = 0;
    $scope.currentPage = 1;
    $scope.selected = null;
    fetch();
  }

  $scope.$on('filters.status', function(event, data) {
    updateFilter('status', data);
  });

  $scope.$on('filters.inviterEmail', function(event, data) {
    updateFilter('inviterEmail', data);
  });

  $scope.$on('filters.inviteeEmail', function(event, data) {
    updateFilter('inviteeEmail', data);
  });

  $scope.$on('filters.bookingReference', function(event, data) {
    updateFilter('bookingReference', data);
  });

  $scope.$on('referrals.exportCSV', function() {
    var queryString = angular.merge({}, $scope.filters, {limit: 0, offset: 0});

    Restangular
      .one('referral-rewards')
      .get(queryString, {'accept': 'text/csv'})
      .then(function(response) {
        var file = new Blob([response], { type: 'text/csv;charset=utf-8' });
        $window.saveAs(file, 'referral-rewards.csv');
      })
      .catch(function() {
        $scope.$emit('notify', {type: 'error', title: 'Download', message: 'Error downloading CSV'});
      });
  });
}

'use strict';

/* exported
  referralsMenuCtrl
 */
function referralsMenuCtrl($scope, $rootScope, $location) {
  $scope.filters = {};

  $scope.filterByStatus = function(status) {
    if ($scope.filters.status === status) {
      $scope.filters.status = null;
    } else {
      $scope.filters.status = status;
    }
    $rootScope.$broadcast('filters.status', $scope.filters.status);

    var search = $location.search();
    search.status = $scope.filters.status;
    $location.search(search);
  };

  $scope.$watch('filters.inviterEmail', function(value) {
    $rootScope.$broadcast('filters.inviterEmail', value);
  });

  $scope.$watch('filters.inviteeEmail', function(value) {
    $rootScope.$broadcast('filters.inviteeEmail', value);
  });

  $scope.$watch('filters.bookingReference', function(value) {
    $rootScope.$broadcast('filters.bookingReference', value);
  });

  $scope.exportCSV = function() {
    $rootScope.$broadcast('referrals.exportCSV');
  };
}
